import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import "./PageNotFound.css";

export const PageNotFound = () => {
  return (
    <Container fluid className="dark-page">
      <Row className="h-100 align-items-center">
        <Col className="text-center">
          <h1 className="display-1">404</h1>
          <p className="lead">Page Not Found</p>
          <p>Sorry, the page you are looking for might be in another galaxy.</p>
          <Button variant="outline-light" href="/">
            Go Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
